import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import {
  useStripe,
  useElements,
  PaymentElement,
  AddressElement,
  ExpressCheckoutElement
} from '@stripe/react-stripe-js';
import { ActivityIndicator, Image, View } from "react-native";
import Button from "./../../../../../components/button/Button";
import { useIsFocused } from '@react-navigation/native';
import ajax from '../../../../../helpers/ajaxHelper';
import Urls from '../../../../../services/Urls';
import getPlatformType from '../../../../../helpers/helpers';
import Colors from '../../../../../constants/Colors';

export const CheckoutForm = (props) => {
  const dispatch = useDispatch();
  const stripe = useStripe();
  const elements = useElements();

  const [user, setUser] = useState({});
  const [loader, setLoader] = useState(false);

  const focused = useIsFocused();
  const layoutType = getPlatformType();

  const userDetails = useSelector(
    (state) => state?.Login?.userDetails
  );

  useEffect(() => {
    ajax
      .get(Urls.PROFILE)
      .then(({ data }) => {
        if (data?.status) {
          setUser(data?.data.userDetails);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  }, [focused]);

  const handleSubmit = async (event) => {
    if (event) {
      event.preventDefault();
    }

    setLoader(true);

    if (!stripe || !elements) {
      setLoader(false);
      return;
    }

    try {
      dispatch({ type: "tenantConstants.MAKE_PAYMENTS" });

      const addressElement = elements.getElement("address");
      const address = await addressElement?.getValue();

      console.log({
        shipping: address?.value
      });

      const response = await stripe.confirmPayment({
        elements,
        redirect: "if_required",
        confirmParams: {
          shipping: address?.value
        }
      });

      console.log("response", response);

      setLoader(false);

      switch (response?.paymentIntent?.status) {
        case "succeeded":
        case "processing":
          props.onSuccessToken(true);
          break;

        case "requires_payment_method":
        default:
          props.onSuccessToken(false);
          break;
      }

      dispatch({
        type: "tenantConstants.MAKE_PAYMENTSSUCCESS"
      });

    } catch (error) {
      setLoader(false);
      console.log(error);

      dispatch({
        type: "tenantConstants.MAKE_PAYMENTSSUCCESS"
      });

      props.onSuccessToken(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>

      {/* NEW: Google Pay / Apple Pay / Link buttons */}
      <ExpressCheckoutElement
        onConfirm={handleSubmit}
        options={{
          paymentMethods: {
            googlePay: "always",
            applePay: "auto"
          }
        }}
      />

      {/* Existing card form */}
      <PaymentElement
        options={{
          defaultValues: {
            billingDetails: {
              email: userDetails?.email,
              name:
                userDetails?.first_name +
                " " +
                userDetails?.last_name,
              phone:
                userDetails?.contact_number
                  ? userDetails?.contact_number
                  : "",
            }
          }
        }}
      />

      {/* Address form */}
      <AddressElement
        options={{
          mode: "billing",
          allowedCountries: ["GB"],
          blockPoBox: true,
          defaultValues: {
            name: user?.first_name
              ? user?.first_name + " " + user?.last_name
              : "",
            address: {
              country: "GB",
            },
          },
          fields: {
            phone: "always",
          },
          validation: {
            phone: {
              required: "never",
            },
          },
        }}
      />

      <Image
        source={require("./../../../../../assets/images/stripe.png")}
        resizeMode="contain"
        style={{
          height: 26,
          width: 119,
          alignSelf: "flex-end",
          marginTop: 24,
        }}
      />

      <View
        style={{
          marginTop: 30,
          width: "100%",
          justifyContent: "center",
          alignItems: "flex-end",
          flexDirection: "row",
        }}
      >
        <Button
          color={Colors.light.red}
          type="stripe"
          childText="Cancel"
          style={{
            width: layoutType === "phone" ? 150 : 200,
            marginRight: 10,
          }}
          onPress={() =>
            props?.onCancel
              ? props?.onCancel()
              : null
          }
        />

        <Button
          color={"#1B8A8C"}
          disabled={loader}
          type="solid"
          childText={
            loader
              ? <ActivityIndicator color={"white"} />
              : "Submit order"
          }
          style={{
            width: layoutType === "phone" ? 150 : 200
          }}
          onPress={handleSubmit}
        />
      </View>
    </form>
  );
};

export default CheckoutForm;